// extracted by mini-css-extract-plugin
export default {"NavbarMainContainer":"Navbar_NavbarMainContainer__Cy4gu","sovrennLogo":"Navbar_sovrennLogo__E-Qyk","NavbarRightDiv":"Navbar_NavbarRightDiv__XYWKP"};